import { render, staticRenderFns } from "./daiban.vue?vue&type=template&id=2b4fa28d&scoped=true"
import script from "./daiban.vue?vue&type=script&lang=js"
export * from "./daiban.vue?vue&type=script&lang=js"
import style0 from "./daiban.vue?vue&type=style&index=0&id=2b4fa28d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4fa28d",
  null
  
)

export default component.exports